import { combineReducers } from 'redux';

import queriesReducer from './queriesReducer';
import profileReducer from './profileReducer';
import tasksReducer from './tasksReducer';
import taskTemplatesReducer from './taskTemplatesReducer';
import paymentReducer from './paymentReducer';
import pricesReducer from '@redux/reducers/pricesReducer';

export default combineReducers({
  queriesReducer,
  profileReducer,
  tasksReducer,
  taskTemplatesReducer,
  paymentReducer,
  prices: pricesReducer
});
